import {useIsGuestSession} from '@sollapay/web-core';

import {useCurrentTrustAccount} from '@/features/trust-accounts/providers';

import {getDeclarationSigner} from '../utils';

import type {DeclarationSigner} from '../utils';

/** Whose words the signature confirmation reads in for the current caller. */
export function useDeclarationSigner(): DeclarationSigner {
  const {isTrustee} = useCurrentTrustAccount();
  const isGuest = useIsGuestSession();
  return getDeclarationSigner({isTrustee, isGuest});
}
